// ===== TENANT THUNKS =====
// src/features/auth/state/tenant-state/tenantThunks.ts

import { createAsyncThunk } from '@reduxjs/toolkit';
import { tenantAPI } from '../../api-layer/clients/AuthAPIClient';
import type { TenantSettings } from '../../api-layer/clients/AuthAPIClient';

export const inviteUserToTenantThunk = createAsyncThunk(
  'tenant/inviteUser',
  async (data: { email: string; role: string; tenantId?: string }) => {
    const response = await tenantAPI.inviteUser(data);
    return response.data;
  }
);

export const updateTenantThunk = createAsyncThunk(
  'tenant/update',
  async (data: { tenantId: string; updates: Partial<TenantSettings> }) => {
    const response = await tenantAPI.updateTenant(data.tenantId, data.updates);
    return response.data;
  }
);

export const fetchTenantMembersThunk = createAsyncThunk(
  'tenant/fetchMembers',
  async (tenantId: string) => {
    const response = await tenantAPI.fetchMembers(tenantId);
    return response.data;
  }
);